<template>
  <div class="table-scroll-x">
    <div v-if="workshopName" class="table-wrapper-salaryList">
      <table class="table-header">
        <colgroup>
          <col style="width: 7%" />
          <col style="width: 4%" />
          <col style="width: 9%" />
          <col style="width: 15%" />
          <col style="width: 26%" />
          <col style="width: 22%" />
          <col style="width: 20%" />
          <col style="width: 8%" />
          <col style="width: 8%" />
          <col style="width: 12%" />
          <col style="width: 7%" />
          <col style="width: 7%" />
        </colgroup>
        <thead>
          <tr class="title-row">
            <th colspan="12">
              <div class="table-title">
                <v-card-text class="pa-0 ma-0 text-body-1">{{
                  workshopName
                }}</v-card-text>
                <v-card-text class="pa-0 ma-0 text-body-1"
                  >{{ $t("listSalary") }} {{ month }}/{{ year }}</v-card-text
                >
              </div>
            </th>
          </tr>
          <tr>
            <th colspan="2">{{ $t("row") }}</th>
            <th>{{ $t("InsurerNumber") }}</th>
            <th>{{ $t("DailyWage") }}</th>
            <!-- <th>{{ $t("Overtime") }}</th> -->
            <th rowspan="2">{{ $t("performance_") }}</th>
            <th rowspan="2">{{ $t("benefit") }}</th>
            <th rowspan="2">{{ $t("deductions") }}</th>
            <th colspan="2">{{ $t("sum") }} {{ $t("benefits&salary") }}</th>
            <th>{{ $t("pay_insurance") }}</th>
            <th colspan="2">{{ $t("sum") }} {{ $t("deductions") }}</th>
          </tr>
          <tr>
            <th colspan="2">{{ $t("name_and_lastName") }}</th>
            <th>{{ $t("performance_") }}</th>
            <th>{{ $t("MonthlyWage") }}</th>
            <!-- <th>{{ $t("OvertimeHour") }}</th> -->
            <th colspan="2">{{ $t("total_covered_benefits&salary") }}</th>
            <th>{{ $t("pay_tax") }}</th>
            <th colspan="2">{{ $t("netPay") }}</th>
          </tr>
        </thead>
      </table>
      <!-- Scrollable part -->
      <div class="scroll-body">
        <table>
          <colgroup>
            <col style="width: 7%" />
            <col style="width: 4%" />
            <col style="width: 9%" />
            <col style="width: 15%" />
            <col style="width: 26%" />
            <col style="width: 22%" />
            <col style="width: 20%" />
            <col style="width: 8%" />
            <col style="width: 8%" />
            <col style="width: 12%" />
            <col style="width: 7%" />
            <col style="width: 7%" />
          </colgroup>
          <tbody>
            <template v-for="(row, index) in tableData">
              <tr :key="'top' + index" class="employee-top-row">
                <td colspan="2">{{ index + 1 }}</td>
                <td class="center-cell-value">{{ row.insurance }}</td>
                <td class="center-cell-value">{{ $numberFormat(row.dailySalary) }}</td>

                <td rowspan="2" class="performance-cell">
                  <div
                    class="nested-list-wrap"
                    :class="{ 'has-toggle': hasOverflow(index, 'performance') }"
                  >
                    <div
                      class="nested-list"
                      :class="{
                        expanded: isExpanded(index, 'performance'),
                        'is-clipped':
                          hasOverflow(index, 'performance') &&
                          !isExpanded(index, 'performance'),
                      }"
                      :data-list-key="index + '-performance'"
                    >
                      <div
                        v-for="(b, i) in row.performances"
                        :key="i"
                        class="performance-item row-eq"
                        :data-row-index="index + '-' + i"
                        :class="i % 2 === 0 ? 'bg-white' : 'bg-gray'"
                      >
                        <v-card-text class="pa-0 ma-0 text-body-2 title">
                          {{ b.title }}
                        </v-card-text>
                        <v-card-text class="pa-0 ma-0 text-body-2 amount">
                          {{ b.amount }}
                        </v-card-text>
                      </div>
                    </div>
                    <v-tooltip v-if="hasOverflow(index, 'performance')" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <button
                          v-bind="attrs"
                          v-on="on"
                          type="button"
                          class="expand-btn"
                          @click="toggleExpand(index, 'performance')"
                        >
                          <v-icon small>
                            {{
                              isExpanded(index, "performance")
                                ? "mdi-chevron-up"
                                : "mdi-chevron-down"
                            }}
                          </v-icon>
                        </button>
                      </template>
                      <span>{{
                        isExpanded(index, "performance") ? "مشاهده کمتر" : "مشاهده بیشتر"
                      }}</span>
                    </v-tooltip>
                  </div>
                </td>
                <td rowspan="2" class="benefits-cell">
                  <div
                    class="nested-list-wrap"
                    :class="{ 'has-toggle': hasOverflow(index, 'benefits') }"
                  >
                    <div
                      class="nested-list"
                      :class="{
                        expanded: isExpanded(index, 'benefits'),
                        'is-clipped':
                          hasOverflow(index, 'benefits') &&
                          !isExpanded(index, 'benefits'),
                      }"
                      :data-list-key="index + '-benefits'"
                    >
                      <div
                        v-for="(b, i) in row.benefits"
                        :key="i"
                        class="benefit-item row-eq"
                        :data-row-index="index + '-' + i"
                        :class="i % 2 === 0 ? 'bg-white' : 'bg-gray'"
                      >
                        <v-card-text class="pa-0 ma-0 text-body-2 title">
                          {{ b.title }}
                        </v-card-text>
                        <v-card-text class="pa-0 ma-0 text-body-2 amount">
                          {{ $numberFormat(b.amount) }}
                        </v-card-text>
                      </div>
                    </div>
                    <v-tooltip v-if="hasOverflow(index, 'benefits')" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <button
                          v-bind="attrs"
                          v-on="on"
                          type="button"
                          class="expand-btn"
                          @click="toggleExpand(index, 'benefits')"
                        >
                          <v-icon small>
                            {{
                              isExpanded(index, "benefits")
                                ? "mdi-chevron-up"
                                : "mdi-chevron-down"
                            }}
                          </v-icon>
                        </button>
                      </template>
                      <span>{{
                        isExpanded(index, "benefits") ? "مشاهده کمتر" : "مشاهده بیشتر"
                      }}</span>
                    </v-tooltip>
                  </div>
                </td>
                <td rowspan="2" class="deduction-cell">
                  <div
                    class="nested-list-wrap"
                    :class="{ 'has-toggle': hasOverflow(index, 'deductions') }"
                  >
                    <div
                      class="nested-list"
                      :class="{
                        expanded: isExpanded(index, 'deductions'),
                        'is-clipped':
                          hasOverflow(index, 'deductions') &&
                          !isExpanded(index, 'deductions'),
                      }"
                      :data-list-key="index + '-deductions'"
                    >
                      <div
                        v-for="(b, i) in row.deductions"
                        :key="i"
                        class="deduction-item row-eq"
                        :data-row-index="index + '-' + i"
                        :class="i % 2 === 0 ? 'bg-white' : 'bg-gray'"
                      >
                        <v-card-text class="pa-0 ma-0 text-body-2 title">
                          {{ b.title }}
                        </v-card-text>
                        <v-card-text class="pa-0 ma-0 text-body-2 amount">
                          {{ $numberFormat(b.amount) }}
                        </v-card-text>
                      </div>
                    </div>
                    <v-tooltip v-if="hasOverflow(index, 'deductions')" bottom>
                      <template v-slot:activator="{ on, attrs }">
                        <button
                          v-bind="attrs"
                          v-on="on"
                          type="button"
                          class="expand-btn"
                          @click="toggleExpand(index, 'deductions')"
                        >
                          <v-icon small>
                            {{
                              isExpanded(index, "deductions")
                                ? "mdi-chevron-up"
                                : "mdi-chevron-down"
                            }}
                          </v-icon>
                        </button>
                      </template>
                      <span>{{
                        isExpanded(index, "deductions") ? "مشاهده کمتر" : "مشاهده بیشتر"
                      }}</span>
                    </v-tooltip>
                  </div>
                </td>
                <td class="center-cell-value" colspan="2">
                  {{ $numberFormat(row.totalBenefits) }}
                </td>
                <td class="center-cell-value">{{ $numberFormat(row.insurancePaid) }}</td>
                <td class="center-cell-value" colspan="2">
                  {{ $numberFormat(row.totalDeductions) }}
                </td>
              </tr>

              <tr :key="'bottom' + index" class="sub-row">
                <td colspan="2">{{ row.name }}</td>
                <td class="center-cell-value">{{ row.workDays }}</td>
                <td class="center-cell-value">{{ $numberFormat(row.monthSalary) }}</td>
                <!-- <td>{{ row.overtimeHours }}</td> -->
                <td class="center-cell-value" colspan="2">
                  {{ $numberFormat(row.coveredtotalBenefits) }}
                </td>
                <td class="center-cell-value">{{ $numberFormat(row.taxPaid) }}</td>
                <td class="center-cell-value" colspan="2">
                  {{ $numberFormat(row.netPay) }}
                </td>
              </tr>
            </template>
          </tbody>
        </table>
      </div>
      <table class="table-footer">
        <colgroup>
          <col style="width: 7%" />
          <col style="width: 4%" />
          <col style="width: 9%" />
          <col style="width: 15%" />
          <col style="width: 26%" />
          <col style="width: 22%" />
          <col style="width: 20%" />
          <col style="width: 8%" />
          <col style="width: 8%" />
          <col style="width: 12%" />
          <col style="width: 7%" />
          <col style="width: 7%" />
        </colgroup>
        <tfoot>
          <tr class="sum-row">
            <td colspan="2" rowspan="2" class="sum-title">{{ $t("sum") }}</td>

            <td>{{ format(sum("workDays")) }}</td>

            <td>{{ $numberFormat(sum("dailySalary")) }}</td>

            <td rowspan="2">{{ $numberFormat(sum("overtimePay")) }}</td>

            <td rowspan="2">{{ $numberFormat(sumBenefits()) }}</td>

            <td rowspan="2">{{ $numberFormat(sumDeductions()) }}</td>

            <td colspan="2">{{ $numberFormat(sum("totalBenefits")) }}</td>

            <td>{{ $numberFormat(sum("insurancePaid")) }}</td>

            <td colspan="2">{{ $numberFormat(sum("totalDeductions")) }}</td>
          </tr>

          <tr class="sum-row">
            <td></td>

            <td>{{ $numberFormat(sum("monthSalary")) }}</td>

            <!-- <td>{{ format(sum("overtimeHours")) }}</td> -->

            <td colspan="2">{{ $numberFormat(sum("coveredtotalBenefits")) }}</td>

            <td>{{ $numberFormat(sum("taxPaid")) }}</td>

            <td colspan="2">{{ $numberFormat(sum("netPay")) }}</td>
          </tr>
        </tfoot>
      </table>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      optionsNew: {
        page: 1,
        itemsPerPage: 10,
      },
      tableData: [],
      workshopName: null,
      month: null,
      year: null,
      expandedEmployees: {},
      overflowEmployees: {},
    };
  },
  computed: {
    totals() {
      const keys = [
        "dailySalary",
        "monthSalary",
        "overtimeHours",
        "overtimePay",
        "insurancePaid",
        "taxPaid",
        "totalDeductions",
        "totalBenefits",
        "coveredtotalBenefits",
        "netPay",
        "workDays",
      ];

      const result = {};

      keys.forEach((key) => {
        result[key] = this.tableData.reduce((sum, row) => {
          return sum + (Number(row[key]) || 0);
        }, 0);
      });

      return result;
    },
  },
  beforeMount() {
    this.getItems();
    this.$nextTick(() => {
      this.equalizeRows();
    });
  },
  updated() {
    this.$nextTick(() => {
      this.equalizeRows();
      this.detectOverflow();
    });
  },
  methods: {
    listKey(index, col) {
      return `${index}-${col}`;
    },
    isExpanded(index, col) {
      return !!this.expandedEmployees[this.listKey(index, col)];
    },
    hasOverflow(index, col) {
      return !!this.overflowEmployees[this.listKey(index, col)];
    },
    toggleExpand(index, col) {
      const key = this.listKey(index, col);
      this.$set(this.expandedEmployees, key, !this.expandedEmployees[key]);
      this.$nextTick(() => {
        this.equalizeRows();
        this.detectOverflow();
      });
    },
    detectOverflow() {
      if (!this.$el) return;
      const next = { ...this.overflowEmployees };
      this.$el.querySelectorAll(".nested-list").forEach((el) => {
        const key = el.getAttribute("data-list-key");
        if (!key) return;
        if (this.expandedEmployees[key]) {
          if (this.overflowEmployees[key]) next[key] = true;
          return;
        }
        next[key] = el.scrollHeight > el.clientHeight + 1;
      });
      const keys = new Set([
        ...Object.keys(next),
        ...Object.keys(this.overflowEmployees),
      ]);
      let changed = false;
      keys.forEach((key) => {
        if (!!next[key] !== !!this.overflowEmployees[key]) changed = true;
      });
      if (changed) this.overflowEmployees = next;
    },
    equalizeRows() {
      const rows = document.querySelectorAll(".row-eq");
      rows.forEach((r) => (r.style.height = "auto"));
      const groups = {};
      rows.forEach((el) => {
        const index = el.getAttribute("data-row-index");
        if (!groups[index]) groups[index] = [];
        groups[index].push(el);
      });
      Object.values(groups).forEach((group) => {
        let max = 0;
        group.forEach((el) => {
          max = Math.max(max, el.offsetHeight);
        });
        group.forEach((el) => {
          el.style.height = max + "px";
        });
      });
    },
    getItems(isPaginate = false) {
      const app = this;

      if (!isPaginate) {
        app.$emit("initial-Loading-is", true);
      }

      const id_ = app.$route.query.id;
      this.paginationLoading = isPaginate;

      app.$axios
        .get(app.$endpoint + "salary/employee-list/" + id_, {
          params: { options: app.optionsNew },
        })
        .then((response) => {
          this.workshopName = response.data?.workshop?.workshop?.name;
          this.month = response.data?.workshop?.month ?? "";
          this.year = response.data?.workshop?.year ?? "";
          const data = [...response.data.salaries.data];
          this.expandedEmployees = {};
          this.overflowEmployees = {};
          this.tableData = data.map((item, index) => {
            const benefits = [];
            const deductions = [];
            const performances = [];
            const configs = Array.isArray(item?.configs)
              ? item.configs
              : Object.values(item?.configs || []);

            configs.forEach((c) => {
              if (c?.factor?.level === "performance") {
                let amountParts = [];

                if (c?.day != null) amountParts.push(`${c.day} روز`);
                if (c?.hour != null) amountParts.push(`${c.hour} ساعت`);
                if (c?.min != null) amountParts.push(`${c.min} دقیقه`);
                if (c?.dayHourMin != null)
                  amountParts.push(`${c.dayHourMin} (دقیقه/روز/ساعت)`);

                const amount = amountParts.join(" ");

                performances.push({
                  title: c?.factor?.name || "",
                  amount: amount,
                });
              }
            });

            if (item.salaries) {
              item.salaries.forEach((s) => {
                if (s.salary?.level === "benefit") {
                  benefits.push({
                    title: s.salary?.name,
                    amount: s.value,
                  });
                }

                if (s.salary?.level === "deductions") {
                  deductions.push({
                    title: s.salary?.name,
                    amount: s.value,
                  });
                }
              });
            }

            const deductionSum = deductions.reduce(
              (sum, d) => sum + Number(d.amount ?? 0),
              0
            );

            const totalDeductions =
              Number(item.tax ?? 0) +
              // Number(item.company_insurance ?? 0) +
              Number(item.employee_insurance ?? 0) +
              deductionSum;

            const totalBenefits = Number(item.benefit ?? 0);
            //
            const stimul_performances_titles =
              performances.length > 0 ? performances.map((p) => p.title).join("\n") : "";
            const stimul_performances_amounts =
              performances.length > 0 ? performances.map((p) => p.amount).join("\n") : "";
            //
            const stimul_benefits_titles =
              benefits.length > 0 ? benefits.map((b) => b.title).join("\n") : "";
            const stimul_benefits_amounts =
              benefits.length > 0
                ? benefits.map((b) => this.$numberFormat(b.amount)).join("\n")
                : "";

            // for deductions
            const stimul_deductions_titles =
              deductions.length > 0 ? deductions.map((d) => d.title).join("\n") : "";
            const stimul_deductions_amounts =
              deductions.length > 0
                ? deductions.map((d) => this.$numberFormat(d.amount)).join("\n")
                : "";

            return {
              row: index + 1,
              name: item.employee?.user?.name || "",
              insurance: item.employee?.insurer_number || "",
              workDays: item.daily_work ?? 0,
              dailySalary: item.base_salary_daily ?? 0,
              monthSalary: item.base_salary ?? 0,
              overtimeHours: item.overtime_hours ?? 0,
              overtimePay: item.overtime_pay ?? 0,
              benefits: benefits.length ? benefits : [{ title: "", amount: 0 }],
              deductions: deductions.length ? deductions : [{ title: "", amount: 0 }],
              performances: performances.length
                ? performances
                : [{ title: "", amount: "" }],
              //add for stimulsoft
              stimul_performances_titles,
              stimul_performances_amounts,
              stimul_benefits_titles,
              stimul_benefits_amounts,
              stimul_deductions_titles,
              stimul_deductions_amounts,
              taxPaid: Number(item.tax ?? 0),
              insurancePaid: Number(item.employee_insurance ?? 0),
              companyInsurance: Number(item.company_insurance ?? 0),
              totalDeductions: totalDeductions,
              totalBenefits: totalBenefits,
              coveredtotalBenefits: Number(item.applicable_insurance_value ?? 0),
              // Number(item.applicable_tax_value ?? 0),

              netPay: totalBenefits - totalDeductions,
            };
          });
          const finalReportData = {
            workshopName: this.workshopName || "",
            month: this.month || "",
            year: this.year || "",
            items: this.tableData,
            totals: {
              workDays: this.sum("workDays"),

              dailySalary: this.$numberFormat(this.sum("dailySalary")),
              monthSalary: this.$numberFormat(this.sum("monthSalary")),
              overtimePay: this.sum("overtimePay"),
              sumBenefits: this.$numberFormat(this.sumBenefits()),
              // MRT expects "sumDeductions" as total final deductions
              // (tax + insurances + deductions), not only deduction items list.
              sumDeductions: this.$numberFormat(this.sum("totalDeductions")),
              totalBenefits: this.$numberFormat(this.sum("totalBenefits")),
              coveredtotalBenefits: this.$numberFormat(this.sum("coveredtotalBenefits")),
              insurancePaid: this.$numberFormat(this.sum("insurancePaid")),
              taxPaid: this.$numberFormat(this.sum("taxPaid")),
              totalDeductions: this.$numberFormat(this.sum("totalDeductions")),
              netPay: this.$numberFormat(this.sum("netPay")),
            },
          };
          const mrtReportData = {
            ...finalReportData,
            month: this.toFaDigits(finalReportData.month),
            year: this.toFaDigits(finalReportData.year),
            items: finalReportData.items.map((row) => ({
              ...row,
              // keep these unformatted per requirement
              row: this.toFaDigits(row.row),
              insurance: this.toFaDigits(row.insurance),
              workDays: this.toFaDigits(row.workDays),
              // format the rest of numeric fields for MRT
              dailySalary: this.toFaDigits(this.$numberFormat(row.dailySalary ?? 0)),
              monthSalary: this.toFaDigits(this.$numberFormat(row.monthSalary ?? 0)),
              overtimeHours: this.toFaDigits(this.$numberFormat(row.overtimeHours ?? 0)),
              overtimePay: this.toFaDigits(this.$numberFormat(row.overtimePay ?? 0)),
              taxPaid: this.toFaDigits(this.$numberFormat(row.taxPaid ?? 0)),
              insurancePaid: this.toFaDigits(this.$numberFormat(row.insurancePaid ?? 0)),
              companyInsurance: this.toFaDigits(
                this.$numberFormat(row.companyInsurance ?? 0)
              ),
              totalDeductions: this.toFaDigits(
                this.$numberFormat(row.totalDeductions ?? 0)
              ),
              totalBenefits: this.toFaDigits(this.$numberFormat(row.totalBenefits ?? 0)),
              coveredtotalBenefits: this.toFaDigits(
                this.$numberFormat(row.coveredtotalBenefits ?? 0)
              ),
              netPay: this.toFaDigits(this.$numberFormat(row.netPay ?? 0)),
              benefits: (row.benefits || []).map((b) => ({
                ...b,
                amount: this.toFaDigits(this.$numberFormat(b.amount ?? 0)),
              })),
              deductions: (row.deductions || []).map((d) => ({
                ...d,
                amount: this.toFaDigits(this.$numberFormat(d.amount ?? 0)),
              })),
              stimul_benefits_amounts: this.toFaDigits(row.stimul_benefits_amounts || ""),
              stimul_deductions_amounts: this.toFaDigits(
                row.stimul_deductions_amounts || ""
              ),
              stimul_performances_amounts: this.toFaDigits(
                row.stimul_performances_amounts || ""
              ),
            })),
            totals: {
              ...finalReportData.totals,
              workDays: this.toFaDigits(finalReportData.totals.workDays),
              dailySalary: this.toFaDigits(finalReportData.totals.dailySalary),
              monthSalary: this.toFaDigits(finalReportData.totals.monthSalary),
              overtimePay: this.toFaDigits(
                this.$numberFormat(finalReportData.totals.overtimePay ?? 0)
              ),
              sumBenefits: this.toFaDigits(finalReportData.totals.sumBenefits),
              sumDeductions: this.toFaDigits(finalReportData.totals.sumDeductions),
              totalBenefits: this.toFaDigits(finalReportData.totals.totalBenefits),
              coveredtotalBenefits: this.toFaDigits(
                finalReportData.totals.coveredtotalBenefits
              ),
              insurancePaid: this.toFaDigits(finalReportData.totals.insurancePaid),
              taxPaid: this.toFaDigits(finalReportData.totals.taxPaid),
              totalDeductions: this.toFaDigits(finalReportData.totals.totalDeductions),
              netPay: this.toFaDigits(finalReportData.totals.netPay),
            },
          };
          this.$emit("salaryListObject", mrtReportData);
        })
        .catch((err) => {
          app.serverErrorHandeler(err);
        })
        .finally(() => {
          app.$emit("initial-Loading-is", false);
          app.$emit("call-refresh");
          app.paginationLoading = false;
        });
    },
    format(n) {
      if (n === null || n === undefined) return "";
      return Number(n).toLocaleString("fa-IR");
    },
    sum(key) {
      return this.tableData.reduce((a, b) => a + (Number(b[key]) || 0), 0);
    },
    sumBenefits() {
      return this.tableData.reduce((total, row) => {
        const rowSum = row.benefits.reduce((s, b) => s + (Number(b.amount) || 0), 0);
        return total + rowSum;
      }, 0);
    },
    sumDeductions() {
      return this.tableData.reduce((total, row) => {
        const rowSum = row.deductions.reduce((s, d) => s + (Number(d.amount) || 0), 0);
        return total + rowSum;
      }, 0);
    },
    toFaDigits(value) {
      if (value === null || value === undefined) return value;
      const faDigits = "۰۱۲۳۴۵۶۷۸۹";
      return String(value).replace(/\d/g, (d) => faDigits[d]);
    },
  },
};
</script>

<style scoped>
.center-cell {
  text-align: center !important;
}
.employee-top-row td {
  border-bottom: 1px solid #949292;
  font-weight: bold;
}
.employee-top-row td[rowspan] {
  border-bottom: 2px solid #333;
}
thead th {
  padding: 6px 4px !important;
  font-size: 11px;
  font-weight: bold;
  text-align: center;
  vertical-align: middle;
}
tfoot td {
  padding: 6px 4px !important;
  font-size: 12px !important;
  font-weight: bold;
  text-align: center;
  vertical-align: middle;
  background: #efefef;
}
.title {
  max-width: 120px;
  white-space: normal;
  word-break: break-word;
}
.amount {
  white-space: nowrap;
}
.bg-white {
  background-color: #ffffff;
}
.bg-gray {
  background-color: #f3f3f3;
}
.table-scroll-x {
  width: 100%;
}
@media (max-width: 1120px) {
  .table-scroll-x {
    overflow-x: auto;
  }
  .table-wrapper-salaryList {
    min-width: 1120px;
  }
}
@media (max-height: 850px) {
  .table-scroll-x {
    overflow-x: auto;
  }
  .table-wrapper-salaryList {
    min-width: 1120px;
  }
}
.signature-cell {
  vertical-align: middle;
  text-align: center;
  font-weight: bold;
}
.table-wrapper-salaryList {
  direction: rtl;
  display: flex;
  flex-direction: column;
  align-items: center;
  background: #fff;
  font-family: IRANSans !important;
  padding: 0px;
  background: #fff;
}

table {
  text-align: center;
  border-collapse: collapse;
  width: 100%;
  font-size: 6px;
  table-layout: fixed;
  border-bottom: 1px solid #666;
}

.scroll-body {
  max-height: min(315px, calc(100vh - 415px));
  overflow-y: auto;
  border-top: none;
  scrollbar-width: none;
  -ms-overflow-style: none;
  scrollbar-color: #888 #e0e0e0;
}
.scroll-body tbody tr td:first-child {
  padding: 2px !important;
}
.scroll-body table {
  border-collapse: collapse;
  border-bottom: 1px solid #666;
}
.scroll-body::-webkit-scrollbar {
  display: none;
}
.scroll-body::-webkit-scrollbar-track {
  background: #e0e0e0;
}
.scroll-body::-webkit-scrollbar-thumb {
  background-color: #888;
  border-radius: 10px;
}
.scroll-body::-webkit-scrollbar-thumb:hover {
  background-color: #666;
}
@media (max-width: 1120px) and (max-height: 726px) {
  .scroll-body {
    max-height: min(300px, calc(100vh - 390px));
  }
}
@media (max-width: 1024px) and (max-height: 600px) {
  .scroll-body {
    max-height: min(250px, calc(100vh - 360px));
  }
}
/* @media (max-width: 1026px) and (max-height: 610px) {
  .scroll-body {
    max-height: 150px;
  }
} */
.table-title {
  text-align: center;
  background: #efefef;
  padding: 0px 0;
}
.title-row th {
  padding: 0;
  border-bottom: none;
  background: #efefef;
}
th {
  background: #efefef;
  padding: 6px;
}
tr {
  padding: 6px;
}
th,
td {
  border: 1px solid #444;
  padding: 0px 1px;
  vertical-align: top;
  text-align: right;
}
td.center-cell-value,
th.center-cell-value {
  text-align: center !important;
  font-size: 11px !important;
}
thead tr:first-child th {
  background: #efefef;
}
thead tr:nth-child(2) th {
  background: #efefef;
}
.sub-row td {
  border-top: 1px dotted #777;
  border-bottom: 2px solid #333;
}

tfoot td {
  background: #f2f2f2;
  font-weight: bold;
  text-align: center;
}
.sum-title {
  text-align: center;
  font-size: 9px;
}
.sum-row td {
  border-top: 2px solid #444;
}
.table-header,
.table-footer,
.scroll-body table {
  width: 100%;
  table-layout: fixed;
  padding: 4px;
  border-collapse: collapse;
}
.right-table td,
.right-table th,
.left-table td,
.left-table th {
  padding: 0px 0px;
  font-size: 4px;
  line-height: 1.1;
}
.right-table td,
.left-table td {
  padding: 1px 4px;
  height: 12px;
}
.right-table,
.left-table {
  border-collapse: collapse;
}
.benefit-item,
.deduction-item,
.performance-item {
  padding: 6px 2px;
  border-radius: 2px;
}
.benefit-item .title,
.performance-item .title,
.deduction-item .title,
.performance-item .amount,
.deduction-item .amount,
.benefit-item .amount {
  font-size: 10px !important;
}

.benefit-item,
.performance-item,
.deduction-item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 4px;
}
.benefits-cell,
.performance-cell,
.deduction-cell {
  padding-top: 2px;
  position: relative;
}
.nested-list-wrap {
  position: relative;
  height: fit-content;
}
.nested-list-wrap.has-toggle {
  padding-bottom: 22px;
}
.nested-list {
  max-height: 200px;
  overflow: hidden;
}
.nested-list.expanded {
  max-height: none;
}
.nested-list.is-clipped {
  -webkit-mask-image: linear-gradient(to bottom, #000 98%, transparent 100%);
  mask-image: linear-gradient(to bottom, #000 98%, transparent 100%);
}
.expand-btn {
  position: absolute;
  left: 50%;
  bottom: 2px;
  transform: translateX(-50%);
  z-index: 2;
  width: 22px;
  height: 22px;
  padding: 0;
  border: none;
  border-radius: 50%;
  background: transparent;
  /* box-shadow: 0 0 0 1px #ccc; */
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
}
.expand-btn:hover {
  background: #eee;
}
@media print {
  .nested-list {
    max-height: none !important;
    overflow: visible !important;
    -webkit-mask-image: none;
    mask-image: none;
  }
  .expand-btn {
    display: none !important;
  }
}
</style>
